export default "//static.tradera.net/touchweb/static/output/images/category-charity.3e080558.svg";